import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap} from "gsap";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {HTH} from "../HTH";
import {HTHGameAssets} from "../HTHGameAssets";
import {HTHHelper} from "../utils/HTHHelper";
import {HTHSound} from "../sound/HTHSound";
import {DisplayObject} from "pixi.js";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";

interface IShakeConfig {
    x: number;
    y: number;
    obj: DisplayObject;
    duration: number;
    Intensity?: number;
    hertz: number;
}

export class HTHBigWinView extends PIXI.Container implements StageLayer {
    private _countupContainer: PIXI.Container;
    private _countUp: BasicBitmapCountUp;
    private _redCountUp: BasicBitmapCountUp;
    // private _spines: PIXI.Sprite[];
    private _bigWinSpine: PIXI.spine.Spine;
    private _explosionTransition: PIXI.spine.Spine;

    constructor() {
        super();
        this.name = "BIG_WIN";
        // this._spines = [];
        this.init();
    }

    private _maxLevel: number;

    public set maxLevel(value: number) {
        this._maxLevel = value;
    }

    public show(duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        this.alpha = 0;
        this.visible = true;
        //  this._countUp.scale.set(0.5);
        // this._countUp.position.set(340, 600);
        // this._redCountUp.position.set(340, 600);
        this._countupContainer.position.set(340, 600);
        this._countUp.setAmount(0);
        this._redCountUp.setAmount(0);

        tl.to(this, {duration: duration, alpha: 1}, 0);
        return tl;
    }

    public hide(duration: number = 0.0001): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        const maxLevel: number = HTHHelper.getBigWinLevel();
        // tl.to(this._countUp, {duration: 0.2, y: 300});
        tl.to(this, {duration: 0.2});
        if (!HTH.model.brokeTheBank) {
            tl.add(HTH.gameViewContainer.hideOverlay());
        }
        tl.to(this, {duration: duration, alpha: 0}, "<");
        tl.add(() => {
            HTHHelper.resetSpineItem(this._bigWinSpine);
            HTHHelper.resetSpineItem(this._explosionTransition);
            this.visible = false;
            this._countUp.visible = false;
            this._redCountUp.visible = false;
        });

        return tl;
    }

    public getLevelAnimation(countFrom: number, countTo: number, duration: number, level: number, currentIndex: number, totalLvlsToPlay: number): gsap.core.Timeline {
        // Logger.logDev("getLevelAnimation called details :: from : " + countFrom + " to : " + countTo + " duration : " + duration + " level : " + level);
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this._bigWinSpine.visible = true;
            this._bigWinSpine.alpha = 0;
            this.addChild(this._countupContainer);
            HTHSound.playTrack(HTHSound.BIGWIN[level - 1]);
        }, 0);
        const scaleTl: gsap.core.Timeline = gsap.timeline(),
            delay: number = 0;
        // scaleTl.to(this, {duration: 0.1});
        scaleTl.add(this.getCountUpScaleAnimation(duration, "power2.in", 1, 0.8, countFrom, countTo));

        tl.add(scaleTl, delay);
        tl.add(HTHHelper.playSpineWithTimeline(this._bigWinSpine, 0, `bigwin_${level}`).totalDuration(duration), "<");
        tl.to(this._bigWinSpine, {duration: 0.05, alpha: 1}, "<");

        tl.add(() => {
            this._countUp.stopAt(countFrom);
            this._redCountUp.stopAt(countFrom);
            this._countUp.visible = true;
            this._redCountUp.visible = true;
            this._redCountUp.alpha = 0;
        }, delay);

        if (currentIndex - 1 !== totalLvlsToPlay) {
            tl.add(this.Shake({
                obj: this._countUp,
                x: 1,
                y: 1,
                hertz: 70,
                Intensity: 3,
                duration: 2
            }), tl.totalDuration() - 2);
            tl.add(this.Shake({
                obj: this._redCountUp,
                x: 1,
                y: 1,
                hertz: 70,
                Intensity: 3,
                duration: 2
            }), "<");
        }

        tl.add(this._countUp.getCountAnimation(countFrom, countTo, duration, "none", level), delay);
        tl.add(this._redCountUp.getCountAnimation(countFrom, countTo, duration, "none", level), "<");
        tl.to(this._redCountUp, {alpha: 1, duration: duration}, "<");
        tl.addLabel("countupComp");
        tl.to(this._countupContainer.scale, {x: 1.1, y: 1.1, duration: 0.1}, "countupComp-=0.2");
        tl.to(this._countupContainer.scale, {x: 1, y: 1, duration: 0.1}, "countupComp-=0.1");


        tl.add(() => {
            this._explosionTransition.rotation = level === 1 ? 0 : level === 2 ? 90 : level === 3 ? 180 : 270;
            this._explosionTransition.state.setAnimation(0, "bw_transition", false);
        }, ">-=0.4");

        //console.log("level :", level, "duration: ", duration);
        //console.log("level :", level, "tl duration: ", tl.totalDuration());
        return tl;
    }

    public onAbort(level: number): void {
        let stopBWNo: number = JSON.parse(JSON.stringify(level));
        if (HTHSound.soundPlayer.fetchSoundPlayer(HTHSound.BIGWIN[stopBWNo])?.isPlaying) {
            HTHSound.stopSound(HTHSound.BIGWIN[stopBWNo]);
        }

    }

    private Shake(config: IShakeConfig): gsap.core.Timeline {
        let startPosY: number = config.obj.y;
        let startPosX: number = config.obj.x;

        let t: boolean = true;
        const tl: gsap.core.Timeline = gsap.timeline({
            onStart: () => {
                startPosY = config.obj.y;
                startPosX = config.obj.x;
            },
            onUpdate: () => {
                const nt: number = tl.progress();
                const lt: number = tl.time();
                let et: number = nt;
                if (t) {
                    t = false;
                    return;
                }
                if (config.Intensity) {
                    if (config.y != 0)
                        config.obj.y = startPosY + Math.cos(lt * config.hertz) * (config.Intensity * et) * config.y;
                    if (config.x != 0)
                        config.obj.x = startPosX + (Math.sin(lt * config.hertz) * (config.Intensity * et)) * config.x;
                } else {
                    if (config.y != 0)
                        config.obj.y = startPosY + (Math.cos(lt * config.hertz) * et) * config.y;
                    if (config.x != 0)
                        config.obj.x = startPosX + (Math.sin(lt * config.hertz) * et) * config.x;
                }
            }
        });
        tl.to(this, {duration: config.duration})
        return tl;
    }

    private init(): void {
        this._countUp = new BasicBitmapCountUp({
            fontName: HTHGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 35,
            tint: 0xffffff
        }, 660, new PIXI.Point(0.5, 0.5));
        this._redCountUp = new BasicBitmapCountUp({
            fontName: HTHGameAssets.BITMAP_FONT_WIN_COUNT_UP_RED,
            fontSize: 35,
        }, 660, new PIXI.Point(0.5, 0.5));
        this._countUp.stopAt(0);
        this._countUp.scale.set(0.5, 0.5);

        this._redCountUp.stopAt(0);


        this._countupContainer = new PIXI.Container();

        this.addChild(this._countupContainer);
        this._countupContainer.addChild(this._countUp, this._redCountUp);
        this._countupContainer.position.set(360, 600);
        this.visible = false;
        this.alpha = 0;
        this._countUp.visible = false;
        this._redCountUp.visible = false;
        this._bigWinSpine = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("BigWins"));
        this._bigWinSpine.position.set(360, 407);
        this._bigWinSpine.scale.set(0.7);
        this.addChild(this._bigWinSpine);
        this._bigWinSpine.visible = false;

        this._explosionTransition = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("BigwinTransition"));
        this._explosionTransition.position.set(360, 360);
        this.addChild(this._explosionTransition);
    }

    private getSpine(level: number): PIXI.Sprite {
        let spine: PIXI.Sprite = new PIXI.Sprite(HTH.assetLoader.getTextures("BWLevel_" + level.toString())[0]);
        spine.anchor.set(0.5, 0.5);
        spine.position.set(360, 360);
        spine.name = "BIGWIN_SPINE_LEVEL_" + level;

        // this._spines.push(spine);
        spine.visible = false;
        return spine;
    }

    private getCountUpScaleAnimation(duration: number, ease: string, to: number, from: number, fromAmount: number, toAmount: number): gsap.core.Timeline {
        //  debugger;
        const tl: gsap.core.Timeline = gsap.timeline();
        if (from != undefined) {
            tl.add(() => {
                this._countUp.scale.set(from, from);
                this._countUp.preCalculateScale(fromAmount, toAmount);
                this._redCountUp.scale.set(from, from);
                this._redCountUp.preCalculateScale(fromAmount, toAmount);
            });
        }
        tl.to(this._countUp.scale, {duration: duration, x: to, y: to, ease: ease});
        tl.to(this._redCountUp.scale, {duration: duration, x: to, y: to, ease: ease}, "<");
        return tl;
    }

    private bigWinExplosion(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        const effect1: TimelineSprite = this.getWinHighlightAnim();
        const effect2: TimelineSprite = this.getWinHighlightAnim();
        tl.add(() => {
            effect1.position.set(-this._countupContainer.width / 2 - 40, -20);
            effect2.position.set(this._countupContainer.width / 2 + 40, -20);
            effect1.scale.set(-1, 1);
            this._countupContainer.addChild(effect1, effect2, this._countUp, this._redCountUp);
        }, 0)
        tl.add(<gsap.core.Timeline><unknown>effect1.getAnimationAutoShowHide());
        tl.add(<gsap.core.Timeline><unknown>effect2.getAnimationAutoShowHide(), "<");
        tl.add(() => {
            this._countupContainer.removeChild(effect1);
            this._countupContainer.removeChild(effect2);
            effect1.destroy();
            effect2.destroy();
        })

        return tl;
    }

    private getWinHighlightAnim(): TimelineSprite {
        let ts: TimelineSprite = new TimelineSprite(HTH.assetLoader.getTextures("bigWinExplosion"));
        ts.position.set(0, 0);
        ts.anchor.set(0.5, 0.5);
        ts.blendMode = PIXI.BLEND_MODES.ADD;
        ts.scale.set(1, 1);
        ts.visible = false;
        ts.name = "winHighlight";
        return ts;
    }
}
